import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { toastService } from "@miplatform/toast";
import { CalendarEventType } from "@miplatform/types";
import { getDate } from "@miplatform/utils";
import { useGlobalManagerApproval } from "@mibuildweb/components";

export const useLogFollowUpViewModel = ({
  calendarId,
  attempt,
  eventType,
  onClose,
  onRefresh,
}) => {
  const stateManager = useComponentState();
  const { executeApiRequest } = useGlobalManagerApproval();

  const hold = ({ contactName, reason, followUpDate }) => {
    stateManager.run(async () => {
      const options = await (eventType === CalendarEventType.WorkOrder
        ? taskService.workOrders.hold({
            id: attempt.assignment?.workOrder?.workOrderId,
            data: {
              id: attempt.assignment?.workOrder?.workOrderId,
              contactName,
              reason,
              followUpDate: getDate(followUpDate),
              calendarId,
              isOnHold: true,
            },
            modifiedOn: attempt.assignment?.workOrder?.modifiedOn,
          })
        : taskService.order.getHoldOptions({
            orderId: attempt.orderId,
            data: {
              contactName,
              modifiedOn: attempt.orderModifiedOn,
              calendarId,
              followUpDate: getDate(followUpDate),
              reason,
            },
          }));

      await executeApiRequest({
        options,
        callback: ({ status }) => {
          if (status === HTTP_STATUSES.OK) {
            toastService.success({
              text: "Order Placed on Hold",
            });

            onRefresh();
            onClose();
          }
        },
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    hold,
  };
};
